const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export function getPromotionSearchTerm(campaign) {
    return String(campaign.MainTitle || '').match(/\bmodel\s*[:：-]\s*([a-z0-9][a-z0-9-]*)/i)?.[1] || campaign.MainTitle || '';
}

export function getPromotionProductUrl(product, language) {
    const id = Number(product.ProductId ?? product.ProductID);
    if (!Number.isInteger(id) || id <= 0) return null;
    return `/${encodeURIComponent(language)}/product-detail/${id}/${encodeURIComponent(product.CategoryName || 'shop')}/${encodeURIComponent(product.ProductName || product.MainTitle || 'product')}`;
}

export function getCampaignProductLink(campaign) {
    const link = String(campaign?.ProductLink || '').trim();
    if (!link) return null;
    try {
        const url = new URL(link);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
    } catch { return null; }
}

export function getPromotionUrl(campaign, language) {
    return getCampaignProductLink(campaign) || getPromotionProductUrl(campaign, language) || `/${encodeURIComponent(language)}/campaign/${campaign.CampaignId}/${encodeURIComponent(campaign.MainTitle || 'promotion')}`;
}

export function matchPromotionProducts(campaign, products) {
    const valid = products.filter(item => Number(item.ProductId ?? item.ProductID) > 0);
    const exact = valid.filter(item => normalize(item.ProductName) === normalize(campaign.MainTitle));
    if (exact.length) return exact;
    const term = getPromotionSearchTerm(campaign);
    if (term === campaign.MainTitle) return [];
    const model = normalize(term);
    return valid.filter(item => normalize(item.SKU || item.Sku) === model ||
        (` ${normalize(item.ProductName)} `).includes(` ${model} `));
}

export async function resolvePromotionUrl(campaign, language, searchProducts) {
    const direct = getCampaignProductLink(campaign) || getPromotionProductUrl(campaign, language);
    if (direct) return direct;
    const term = getPromotionSearchTerm(campaign);
    if (term && searchProducts) {
        try {
            const results = await searchProducts(term);
            const matches = matchPromotionProducts(campaign, results);
            const total = Number(results?.[0]?.TotalRecords || results?.length || 0);
            if (matches.length === 1 && total <= results.length) {
                return getPromotionProductUrl(matches[0], language);
            }
        } catch (error) {
            console.error('Unable to resolve promoted product', error);
        }
    }
    return getPromotionUrl(campaign, language);
}
